import React from 'react';
import { COMPANY_INFO } from '../constants/company';
import './HeroSection.css';

const HeroSection = () => (
  <section className="hero" aria-label="Hero">
    <div className="hero__container">
      <h1 className="hero__title">CenterSoftech</h1>
      <p className="hero__desc">Building things for phones and the web.</p>

      <p className="hero__link">
        <a href="https://beberoutine.com" target="_blank" rel="noopener noreferrer">BeBeRoutine ↗</a>
      </p>

      <p className="hero__contact">
        <a href={`mailto:${COMPANY_INFO.contact.email}`}>{COMPANY_INFO.contact.email}</a>
        <span>Seoul, Korea</span>
      </p>

      <p className="hero__notice">Full website coming soon.</p>
    </div>
  </section>
);

export default HeroSection;
